/** Must match `api/src/spatial/spatial-data-source.constants.ts` (stored as feature_flag.key). */
export const SPATIAL_DATA_SOURCE_LOCATION = 'spatial-data-source-location';
export const SPATIAL_DATA_SOURCE_CSV = 'spatial-data-source-csv';
